const config = {
  SAMS_ENDPOINT: 'https://sams2.usps.gov/sams-intl-ws/assignment/fetchbyupu/MIA/',
    ENDPOINT: '/dangerous-ws',
    BASE_URL: '/dangerous-goods-web',
    LOGIN: 'external' // For SIT-External, PROD-External
  }
  
  export default config
  